import React from 'react';
import TreasureMap from './TreasureMap';
import { GeoAltFill, PeopleFill, BoxSeam } from 'react-bootstrap-icons';

const TreasureHuntReport = ({ treasureHuntEvents }) => {
  if (!treasureHuntEvents || treasureHuntEvents.length === 0) {
    return <p>표시할 보물찾기 이벤트가 없습니다.</p>;
  }

  return (
    <div>
      {treasureHuntEvents.map(event => (
        <div key={event.eventKey} className="card mb-4 shadow-sm">
          <div className="card-header bg-success text-white">
            <h3 className="mb-0">{event.eventName} ({event.statusName})</h3>
          </div>
          <div className="card-body">
            <div className="row">
              {/* Map Column */}
              <div className="col-md-8">
                <h4 className="mb-3"><GeoAltFill className="me-2" />보물 상자 지도</h4>
                {event.treasureBoxes && event.treasureBoxes.length > 0 ? (
                  <div style={{ border: '1px solid #ddd', borderRadius: '0.25rem', height: '400px' }}>
                    {console.log('Rendering TreasureMap with transformed treasureBoxes:', event.treasureBoxes)}
                    <TreasureMap markers={event.treasureBoxes.map((box, index) => ({
                      boxKey: `${event.eventKey}-box-${index}`,
                      latitude: box.latitude,
                      longitude: box.longitude,
                      boxName: box.boxName, // Assuming these properties exist in treasureBoxes
                      itemName: box.itemName,
                      remainingCount: box.remainingCount,
                    }))} />
                  </div>
                ) : (
                  <div className="alert alert-info">표시할 보물 상자가 없습니다.</div>
                )}
              </div>

              {/* Stats and Items Column */}
              <div className="col-md-4">
                {/* Stats Card */}
                <div className="card mb-3">
                  <div className="card-header">
                    <h5 className="mb-0">이벤트 요약</h5>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      <PeopleFill className="me-2" />
                      <strong>참가자:</strong> {event.participantCount} 명
                    </p>
                    <p className="card-text">
                      <PeopleFill className="me-2" />
                      <strong>오늘 가입자:</strong> {event.todaySignups} 명
                    </p>
                    <p className="card-text">
                      <BoxSeam className="me-2" />
                      <strong>총 보물 상자:</strong> {event.totalBoxes} 개
                    </p>
                    <p className="card-text">
                      <BoxSeam className="me-2" />
                      <strong>남은 총 상품:</strong> {event.totalRemainingCount} 개
                    </p>
                    <p className="card-text">
                      <BoxSeam className="me-2" />
                      <strong>브랜드 노출 횟수:</strong> {event.brandExposure} 회
                    </p>
                  </div>
                </div>

                {/* Items Card */}
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">상품 목록</h5>
                  </div>
                  <div className="card-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {event.items && event.items.length > 0 ? (
                      <ul className="list-group list-group-flush">
                        {event.items.map(item => (
                          <li key={item.itemkey} className="list-group-item d-flex justify-content-between align-items-center">
                            {item.itemname}
                            <span className="badge bg-primary rounded-pill">{item.itemcount}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>표시할 상품 목록이 없습니다.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TreasureHuntReport;